'use client';

import Script from 'next/script';

/**
 * Naver 트래킹 스크립트. Render-blocking 방지를 위해 afterInteractive 전략으로 지연 로드.
 * Server Component인 app/layout.tsx에서 직접 `<Script onLoad={...}>`를 쓰면
 * "Event handlers cannot be passed to Client Component props" 에러가 발생하므로
 * 반드시 이 Client Component 파일로 감싸서 사용해야 한다.
 */
const NaverWcslog = () => {
  return (
    <Script
      id="naver-wcslog"
      src="https://wcs.naver.net/wcslog.js"
      strategy="afterInteractive"
      onLoad={() => {
        const w = window as unknown as {
          wcs_add?: Record<string, string>;
          _nasa?: Record<string, unknown>;
          wcs?: { inflow: () => void };
          wcs_do?: () => void;
        };
        if (!w.wcs_add) w.wcs_add = {};
        w.wcs_add['wa'] = 's_2da1c1fb4761';
        if (!w._nasa) w._nasa = {};
        if (w.wcs && w.wcs_do) {
          w.wcs.inflow();
          w.wcs_do();
        }
      }}
    />
  );
};

export default NaverWcslog;
